/**
 * One Bexio invoice status, rendered the same way wherever it appears.
 *
 * MOVED VERBATIM out of `BexioInvoicesPage` (3B-1) — same tone map, same
 * classes, same label lookup — following the precedent `bexioFormat`'s
 * `INVOICE_MAPPING_STATUS_LABEL` block and `mapping/BexioBadge` set: a
 * definition that two surfaces need stops living inside one of them. The
 * tenancy detail's Finanzen tab shows the same mirrored invoices as the
 * workspace list, and a second tone table would drift the first time a status
 * is restyled on one page only.
 *
 * NOT MERGED WITH `BexioCountedDocumentsTable`'s copy, deliberately. That one
 * carries three tones and falls back to muted for the rest, so `canceled`
 * renders neutral there and red here. Folding them together would change how
 * the reconciliation table looks — a behaviour change dressed as a cleanup, on
 * a surface this slice has no business touching.
 */
import React from "react";

import { INVOICE_STATUS_LABEL, mapLabel } from "./bexioFormat";

/** Status pill tone. Colour is never the only carrier — the label says it too. */
export const STATUS_TONE = {
  paid: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-400",
  partial:
    "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300",
  pending:
    "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300",
  canceled:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-300",
  draft: "border-border bg-muted text-muted-foreground",
  unknown: "border-border bg-muted text-muted-foreground",
};

export default function StatusPill({ status }) {
  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${
        STATUS_TONE[status] || STATUS_TONE.unknown
      }`}
    >
      {mapLabel(INVOICE_STATUS_LABEL, status)}
    </span>
  );
}
